import { Field } from "@progress/kendo-react-form";
import { useTranslation } from "react-i18next";
import useEnumData from "../../../utils/enums";
import {
  FormDropDownList,
  FormInput,
  FormNumericTextBox,
  FormSwitch,
} from "../../../components/sys-form/FormComponents";
import {
  availabilityValidator,
  requiredValidator,
} from "../../../components/sys-form/FormValidators";
import { cloneElement, useEffect, useState } from "react";
import PersonelService from "../../../services/srv-personel/PersonelService";
import AffiliateService from "../../../services/srv-affiliate/AffiliateService";
import CountryService from "../../../services/srv-country/CountryService";
import DepartmentService from "../../../services/srv-department/DepartmentService";
import { GraphService } from "../../../services/GraphService";
import { AZURE_ROOMS_EMAIL } from "../../../config/globalVariables";
import { Alert } from "@mui/material";

export const EventFormEventTypeInfo = ({ formRenderProps }) => {
  const { t } = useTranslation();
  const [personelData, setPersonelData] = useState([]);
  const [affiliateData, setAffiliateData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [guestPICData, setGuestPICData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const {
    DATAYESNO,
    DATALAUNCHTYPE,
    DATAONLINEPHYSICAL,
    DATAMEETINGTYPE,
    DATAINTERNALEXTERNAL,
    DATAYEARENDMEETINGTYPE,
    DATAREGIONALMEETINGTYPE,
    DATAREGIONALMEALTYPE,
    DATATRAVELTYPE,
    DATASPONSORSHIPTYPE,
    DATATRAININGSEMINARTYPE,
    DATAINTERNALCOMMUNICATIONTYPE,
  } = useEnumData();

  const getAvailabilityColor = (status) => {
    switch (status) {
      case "available":
        return "#4CAF50";
      case "unavailable":
        return "#F44336";
      case "tentative":
        return "#2196F3";
      default:
        return "#666";
    }
  };

  const LocationsItemRender = (li, itemProps) => {
    const itemChildren = (
      <li className="k-list-item" style={{ padding: "8px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span
            style={{
              backgroundColor: "#2196F3",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "8px",
            }}
          >
            <i
              className="fal fa-regular fa-door-closed"
              style={{ color: "#fff" }}
            ></i>
          </span>
          <div>
            <div style={{ fontWeight: "bold" }}>
              {itemProps.dataItem.displayName}
            </div>
            <div
              style={{
                fontSize: "12px",
              }}
            >
              <b
                style={{
                  color: getAvailabilityColor(itemProps.dataItem.isAvailable),
                }}
              >
                <i class="far fa-solid fa-clock"></i>{" "}
                {t(itemProps.dataItem.isAvailable)}
              </b>{" "}
              <span>
                <i class="fas fa-regular fa-user"></i>{" "}
                {itemProps.dataItem.capacity}
              </span>{" "}
              <span>
                <i class="fas fa-map-marker-alt"></i>{" "}
                {itemProps.dataItem.roomsDisplayName}
              </span>
            </div>
          </div>
        </div>
      </li>
    );

    return cloneElement(li, li.props, itemChildren);
  };

  useEffect(() => {
    var etkinlikTipi = formRenderProps.valueGetter("etkinliK_TIPI_KODU");
    var bolumKodu = formRenderProps.valueGetter("boluM_KODU");

    if (etkinlikTipi === "FACTORY_TOUR(MARKETING)") {
      PersonelService.getList().then((data) => {
        setPersonelData(data);
      });
    }

    if (etkinlikTipi === "VISIT_TO_TURKEY") {
      AffiliateService.getList().then((data) => {
        setAffiliateData(data);
      });
    }

    if (etkinlikTipi === "VISIT_TO_TURKEY") {
      CountryService.getList().then((data) => {
        setCountryData(data);
      });
    }

    if (
      etkinlikTipi === "FACTORY_TOUR(MARKETING)" ||
      etkinlikTipi === "VISIT_TO_TURKEY"
    ) {
      DepartmentService.getList().then((data) => {
        setDepartmentData(data);
      });
    }

    if (
      etkinlikTipi === "TRAINING_SEMINAR" ||
      etkinlikTipi === "MEETING" ||
      etkinlikTipi === "LAUNCH"
    ) {
      getLocations();
    }

    if (bolumKodu === "FACTORY") {
      PersonelService.getGuestPICList().then((data) => {
        setGuestPICData(data);
      });
    }
  }, []);

  const handleChange = (fieldName, value) => {
    formRenderProps.onChange(fieldName, {
      value: value,
    });
  };

  const getLocations = async () => {
    GraphService.getRooms(AZURE_ROOMS_EMAIL).then((roomsData) => {
      const roomsEmails = roomsData.map((room) => room.emailAddress);
      var baslangic = formRenderProps.valueGetter("baS_TAR");
      var bitis = formRenderProps.valueGetter("biT_TAR");
      GraphService.checkRoomAvailability(roomsEmails, baslangic, bitis).then(
        (roomsAvailabilityData) => {
          const roomsWithAvailability = roomsData.map((room) => {
            const availabilityInfo = roomsAvailabilityData.find(
              (availability) => availability.roomEmail === room.emailAddress
            );
            var isAvailable =
              !availabilityInfo?.scheduleItems?.length === true
                ? "available"
                : availabilityInfo?.scheduleItems?.length > 0 &&
                  availabilityInfo.scheduleItems.some(
                    (item) => item.status === "busy"
                  )
                ? "unavailable"
                : "tentative";
            return {
              ...room,
              isAvailable,
            };
          });
          setLocations(roomsWithAvailability);
        }
      );
    });
  };

  return (
    <div>
      {formRenderProps.valueGetter("etkinliK_TANIM_ID") &&
        (formRenderProps.valueGetter("etkinliK_TIPI_KODU") ===
          "TRAINING_SEMINAR" ||
          formRenderProps.valueGetter("etkinliK_TIPI_KODU") === "LAUNCH" ||
          formRenderProps.valueGetter("etkinliK_TIPI_KODU") === "MEETING") && (
          <Alert severity="warning">
            {t("meeting_information_change_message")}
          </Alert>
        )}

      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") ===
      "INTERNAL_COMMUNICATIONS" ? (
        <Field
          id="iC_ILETISIM_TIPI"
          name="iC_ILETISIM_TIPI"
          label={t("internal_communication_type")}
          component={FormDropDownList}
          data={DATAINTERNALCOMMUNICATIONTYPE}
          textField="text"
          valueField="value"
          validator={(value) => requiredValidator(value, t)}
          value={formRenderProps.valueGetter("iC_ILETISIM_TIPI")}
          onChange={(e) => handleChange("iC_ILETISIM_TIPI", e.value.value)}
        />
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") ===
      "END_OF_YEAR_MEETINGS" ? (
        <Field
          id="yilsonU_TOPLANTI_TIPI"
          name="yilsonU_TOPLANTI_TIPI"
          label={t("yearend_meeting_type")}
          component={FormDropDownList}
          data={DATAYEARENDMEETINGTYPE}
          textField="text"
          valueField="value"
          validator={(value) => requiredValidator(value, t)}
          value={formRenderProps.valueGetter("yilsonU_TOPLANTI_TIPI")}
          onChange={(e) => handleChange("yilsonU_TOPLANTI_TIPI", e.value.value)}
        />
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") ===
      "REGIONAL_MEETING" ? (
        <Field
          id="bolgeseL_TOPLANTI_TIPI"
          name="bolgeseL_TOPLANTI_TIPI"
          label={t("regional_meeting_type")}
          component={FormDropDownList}
          data={DATAREGIONALMEETINGTYPE}
          textField="text"
          valueField="value"
          validator={(value) => requiredValidator(value, t)}
          value={formRenderProps.valueGetter("bolgeseL_TOPLANTI_TIPI")}
          onChange={(e) =>
            handleChange("bolgeseL_TOPLANTI_TIPI", e.value.value)
          }
        />
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") ===
      "REGIONAL_DINNER" ? (
        <Field
          id="bolgeseL_YEMEK_TIPI"
          name="bolgeseL_YEMEK_TIPI"
          label={t("regional_meal_type")}
          component={FormDropDownList}
          data={DATAREGIONALMEALTYPE}
          textField="text"
          valueField="value"
          validator={(value) => requiredValidator(value, t)}
          value={formRenderProps.valueGetter("bolgeseL_YEMEK_TIPI")}
          onChange={(e) => handleChange("bolgeseL_YEMEK_TIPI", e.value.value)}
        />
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") === "TRAVEL" ? (
        <Field
          id="seyahaT_TIPI"
          name="seyahaT_TIPI"
          label={t("travel_type")}
          component={FormDropDownList}
          data={DATATRAVELTYPE}
          textField="text"
          valueField="value"
          validator={(value) => requiredValidator(value, t)}
          value={formRenderProps.valueGetter("seyahaT_TIPI")}
          onChange={(e) => handleChange("seyahaT_TIPI", e.value.value)}
        />
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") === "TRIP" ? (
        <Field
          id="uruN_KONTROL"
          name="uruN_KONTROL"
          label={t("product_control")}
          component={FormDropDownList}
          data={DATAYESNO}
          textField="text"
          valueField="value"
          validator={(value) => requiredValidator(value, t)}
          value={formRenderProps.valueGetter("uruN_KONTROL")}
          onChange={(e) => handleChange("uruN_KONTROL", e.value.value)}
        />
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") === "SPONSORSHIP" ? (
        <Field
          id="sponsorluK_TIPI"
          name="sponsorluK_TIPI"
          label={t("sponsorship_type")}
          component={FormDropDownList}
          data={DATASPONSORSHIPTYPE}
          textField="text"
          valueField="value"
          validator={(value) => requiredValidator(value, t)}
          value={formRenderProps.valueGetter("sponsorluK_TIPI")}
          onChange={(e) => handleChange("sponsorluK_TIPI", e.value.value)}
        />
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") ===
      "FACTORY_TOUR(MARKETING)" ? (
        <>
          <Field
            id="taleP_EDEN_DEPARTMAN_KODU"
            name="taleP_EDEN_DEPARTMAN_KODU"
            label={t("requester_department")}
            component={FormDropDownList}
            data={departmentData}
            textField="departmaN_KODU"
            valueField="departmaN_KODU"
            extraField="departmaN_ADI"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("taleP_EDEN_DEPARTMAN_KODU")}
            onChange={(e) =>
              handleChange("taleP_EDEN_DEPARTMAN_KODU", e.value.departmaN_KODU)
            }
          />
          <Field
            id="satiS_TEMSILCISI_SICIL_NO"
            name="satiS_TEMSILCISI_SICIL_NO"
            label={t("sales_representative")}
            component={FormDropDownList}
            data={personelData}
            textField="aD_SOYAD"
            valueField="siciL_NO"
            extraField="mail"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("satiS_TEMSILCISI_SICIL_NO")}
            onChange={(e) =>
              handleChange("satiS_TEMSILCISI_SICIL_NO", e.value.siciL_NO)
            }
          />
          <Field
            name="projE_ADI"
            id="projE_ADI"
            label={t("project_name")}
            component={FormInput}
            validator={(value) => requiredValidator(value, t)}
          />
          <Field
            id="projE_BEDELI"
            name="projE_BEDELI"
            label={t("project_cost")}
            component={FormNumericTextBox}
            format="n0"
            validator={(value) => requiredValidator(value, t)}
          />
        </>
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") ===
      "TRAINING_SEMINAR" ? (
        <>
          <Field
            id="egitiM_SEMINER"
            name="egitiM_SEMINER"
            label={t("training_seminar")}
            component={FormDropDownList}
            data={DATATRAININGSEMINARTYPE}
            textField="text"
            valueField="value"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("egitiM_SEMINER")}
            onChange={(e) => handleChange("egitiM_SEMINER", e.value.value)}
          />

          <Field
            id="onlinE_FIZIKI"
            name="onlinE_FIZIKI"
            label={t("online_physical")}
            component={FormDropDownList}
            data={DATAONLINEPHYSICAL}
            textField="text"
            valueField="value"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("onlinE_FIZIKI")}
            onChange={(e) => {
              handleChange("onlinE_FIZIKI", e.value.value);

              handleChange("teams", null);
              handleChange("lokasyon", null);
              handleChange("lokasyoN_ADI", null);
              handleChange("lokasyoN_AVAILABLE", null);
              handleChange("toplantI_URL", null);
            }}
          />

          <Field
            id="teams"
            name="teams"
            label={t("teams_meeting")}
            component={FormSwitch}
            checked={formRenderProps.valueGetter("teams") === "EVET"}
            onChange={(e) => handleChange("teams", e.value ? "EVET" : "HAYIR")}
          />

          <Field
            name="toplantI_URL"
            id="toplantI_URL"
            label={t("meeting_url")}
            component={FormInput}
          />

          <Field
            id="lokasyon"
            name="lokasyon"
            label={t("location")}
            component={FormDropDownList}
            itemRender={LocationsItemRender}
            data={locations}
            filterable
            textField="nickname"
            valueField="id"
            // validator={(value) =>
            //   availabilityValidator(
            //     value,
            //     formRenderProps.valueGetter("lokasyoN_AVAILABLE"),
            //     t
            //   )
            // }
            value={formRenderProps.valueGetter("lokasyon")}
            onChange={(e) => {
              handleChange("lokasyon", e.value.id);
              handleChange("lokasyoN_ADI", e.value.nickname);
              handleChange("lokasyoN_EMAIL", e.value.emailAddress);
              handleChange("lokasyoN_ADRES", e.value.address.city);
              handleChange(
                "lokasyoN_AVAILABLE",
                e.value.isAvailable === "available" ? true : false
              );
            }}
          />

          <Field
            name="egitmen"
            id="egitmen"
            label={t("trainer")}
            component={FormInput}
            validator={(value) => requiredValidator(value, t)}
          />
        </>
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") === "LAUNCH" ? (
        <>
          <Field
            id="lansmaN_TIPI"
            name="lansmaN_TIPI"
            label={t("launch_type")}
            component={FormDropDownList}
            data={DATALAUNCHTYPE}
            textField="text"
            valueField="value"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("lansmaN_TIPI")}
            onChange={(e) => handleChange("lansmaN_TIPI", e.value.value)}
          />

          <Field
            id="onlinE_FIZIKI"
            name="onlinE_FIZIKI"
            label={t("online_physical")}
            component={FormDropDownList}
            data={DATAONLINEPHYSICAL}
            textField="text"
            valueField="value"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("onlinE_FIZIKI")}
            onChange={(e) => {
              handleChange("onlinE_FIZIKI", e.value.value);

              handleChange("teams", null);
              handleChange("lokasyon", null);
              handleChange("lokasyoN_ADI", null);
              handleChange("lokasyoN_AVAILABLE", null);
              handleChange("toplantI_URL", null);
            }}
          />

          <Field
            id="teams"
            name="teams"
            label={t("teams_meeting")}
            component={FormSwitch}
            checked={formRenderProps.valueGetter("teams") === "EVET"}
            onChange={(e) => handleChange("teams", e.value ? "EVET" : "HAYIR")}
          />

          <Field
            name="toplantI_URL"
            id="toplantI_URL"
            label={t("meeting_url")}
            component={FormInput}
          />

          <Field
            id="lokasyon"
            name="lokasyon"
            label={t("location")}
            component={FormDropDownList}
            itemRender={LocationsItemRender}
            data={locations}
            filterable
            textField="nickname"
            valueField="id"
            // validator={(value) =>
            //   availabilityValidator(
            //     value,
            //     formRenderProps.valueGetter("lokasyoN_AVAILABLE"),
            //     t
            //   )
            // }
            value={formRenderProps.valueGetter("lokasyon")}
            onChange={(e) => {
              handleChange("lokasyon", e.value.id);
              handleChange("lokasyoN_ADI", e.value.nickname);
              handleChange("lokasyoN_ADRES", e.value.address.city);
              handleChange("lokasyoN_EMAIL", e.value.emailAddress);
              handleChange(
                "lokasyoN_AVAILABLE",
                e.value.isAvailable === "available" ? true : false
              );
            }}
          />
        </>
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") === "MEETING" ? (
        <>
          <Field
            id="toplantI_TIPI"
            name="toplantI_TIPI"
            label={t("meeting_type")}
            component={FormDropDownList}
            data={DATAMEETINGTYPE}
            textField="text"
            valueField="value"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("toplantI_TIPI")}
            onChange={(e) => handleChange("toplantI_TIPI", e.value.value)}
          />

          <Field
            id="onlinE_FIZIKI"
            name="onlinE_FIZIKI"
            label={t("online_physical")}
            component={FormDropDownList}
            data={DATAONLINEPHYSICAL}
            textField="text"
            valueField="value"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("onlinE_FIZIKI")}
            onChange={(e) => {
              handleChange("onlinE_FIZIKI", e.value.value);

              handleChange("teams", null);
              handleChange("lokasyon", null);
              handleChange("lokasyoN_ADI", null);
              handleChange("lokasyoN_AVAILABLE", null);
              handleChange("toplantI_URL", null);
            }}
          />

          <Field
            id="teams"
            name="teams"
            label={t("teams_meeting")}
            component={FormSwitch}
            checked={formRenderProps.valueGetter("teams") === "EVET"}
            onChange={(e) => handleChange("teams", e.value ? "EVET" : "HAYIR")}
          />

          <Field
            name="toplantI_URL"
            id="toplantI_URL"
            label={t("meeting_url")}
            component={FormInput}
          />

          <Field
            id="lokasyon"
            name="lokasyon"
            label={t("location")}
            component={FormDropDownList}
            itemRender={LocationsItemRender}
            data={locations}
            filterable
            textField="nickname"
            valueField="id"
            // validator={(value) =>
            //   availabilityValidator(
            //     value,
            //     formRenderProps.valueGetter("lokasyoN_AVAILABLE"),
            //     t
            //   )
            // }
            value={formRenderProps.valueGetter("lokasyon")}
            onChange={(e) => {
              handleChange("lokasyon", e.value.id);
              handleChange("lokasyoN_ADI", e.value.nickname);
              handleChange("lokasyoN_ADRES", e.value.address.city);
              handleChange("lokasyoN_EMAIL", e.value.emailAddress);
              handleChange(
                "lokasyoN_AVAILABLE",
                e.value.isAvailable === "available" ? true : false
              );
            }}
          />

          <Field
            id="sirkeT_ICI_SIRKET_DISI"
            name="sirkeT_ICI_SIRKET_DISI"
            label={t("internal_external")}
            component={FormDropDownList}
            data={DATAINTERNALEXTERNAL}
            textField="text"
            valueField="value"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("sirkeT_ICI_SIRKET_DISI")}
            onChange={(e) =>
              handleChange("sirkeT_ICI_SIRKET_DISI", e.value.value)
            }
          />
        </>
      ) : undefined}
      {formRenderProps.valueGetter("etkinliK_TIPI_KODU") ===
      "VISIT_TO_TURKEY" ? (
        <>
          <Field
            id="taleP_EDEN_AFFILIATE_KODU"
            name="taleP_EDEN_AFFILIATE_KODU"
            label={t("requester_affiliate")}
            component={FormDropDownList}
            data={affiliateData}
            textField="affiliatE_KODU"
            valueField="affiliatE_KODU"
            extraField="affiliatE_ADI"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("taleP_EDEN_AFFILIATE_KODU")}
            onChange={(e) =>
              handleChange("taleP_EDEN_AFFILIATE_KODU", e.value.affiliatE_KODU)
            }
          />
          <Field
            id="faturA_EDILECEK_DEPARTMAN_KODU"
            name="faturA_EDILECEK_DEPARTMAN_KODU"
            label={t("department_to_be_billed")}
            component={FormDropDownList}
            data={departmentData}
            textField="departmaN_KODU"
            valueField="departmaN_KODU"
            extraField="departmaN_ADI"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter(
              "faturA_EDILECEK_DEPARTMAN_KODU"
            )}
            onChange={(e) =>
              handleChange(
                "faturA_EDILECEK_DEPARTMAN_KODU",
                e.value.departmaN_KODU
              )
            }
          />
          <Field
            id="faturA_EDILECEK_AFFILIATE_KODU"
            name="faturA_EDILECEK_AFFILIATE_KODU"
            label={t("affiliate_to_be_billed")}
            component={FormDropDownList}
            data={affiliateData}
            textField="affiliatE_KODU"
            valueField="affiliatE_KODU"
            extraField="affiliatE_ADI"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter(
              "faturA_EDILECEK_AFFILIATE_KODU"
            )}
            onChange={(e) =>
              handleChange(
                "faturA_EDILECEK_AFFILIATE_KODU",
                e.value.affiliatE_KODU
              )
            }
          />
          <Field
            id="taleP_EDEN_ULKE_KODU"
            name="taleP_EDEN_ULKE_KODU"
            label={t("requester_country")}
            component={FormDropDownList}
            data={countryData}
            textField="ulkE_KODU"
            valueField="ulkE_KODU"
            extraField="ulkE_ADI"
            validator={(value) => requiredValidator(value, t)}
            value={formRenderProps.valueGetter("ulkE_KODU")}
            onChange={(e) =>
              handleChange("taleP_EDEN_ULKE_KODU", e.value.ulkE_KODU)
            }
          />
        </>
      ) : undefined}
      {formRenderProps.valueGetter("boluM_KODU") === "FACTORY" ? (
        <>
          {formRenderProps.valueGetter("misafiR_SAYISI") > 0 && (
            <Field
              name="misafiR_SORUMLUSU"
              id="misafiR_SORUMLUSU"
              label={t("guest_pic")}
              component={FormDropDownList}
              data={guestPICData}
              textField="aD_SOYAD"
              valueField="mail"
              validator={(value) => requiredValidator(value, t)}
              filterable={true}
              value={formRenderProps.valueGetter("misafiR_SORUMLUSU")}
              onChange={(e) => {
                formRenderProps.onChange("misafiR_SORUMLUSU", {
                  value: e.value.mail,
                });
              }}
            />
          )}

          <Field
            name="ilgilenileN_URUN_GRUBU"
            id="ilgilenileN_URUN_GRUBU"
            label={t("focus_on_product_group")}
            component={FormInput}
            validator={(value) => requiredValidator(value, t)}
          />
        </>
      ) : undefined}
    </div>
  );
};
